import { render } from "./content-chapters.vue?vue&type=template&id=6c9223ea&ts=true"
import script from "./content-chapters.vue?vue&type=script&lang=ts"
export * from "./content-chapters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__